import { useContext, useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import useSubmission from "../hooks/useSubmission";
import { ToastContext } from "../Components/ToastProvider";
import usePageTitle from "../hooks/usePageTitle";
import LoadingButton from "../Components/LoadingButton";

function RestaurantSubmit(id) {
  const { error, submitRestaurant } = useSubmission();

  const { createToast, dismissToast } = useContext(ToastContext);

  const navigate = useNavigate();
  const { authed, profile } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [title, setTitle] = useState("");
  const [address, setAddress] = useState("");
  const [googlemaps, setGooglemaps] = useState("");
  const [description, setDescription] = useState("");
  const [info, setInfo] = useState("");
  const [link, setLink] = useState("");

  const [disabled, setDisabled] = useState(false);

  const handleSubmit = (event) => {
    setDisabled(true);
    event.preventDefault();
    dismissToast(id);
    const data = {
      name,
      email,
      title,
      address,
      googlemaps,
      description,
      info,
      link,
    };
    submitRestaurant(data).then(async (success) => {
      if (success) {
        createToast(
          "You will receive an email from us shortly! 💌",
          "success",
          true,
        );
        navigate("/");
      } else {
        createToast("Something went wrong. Please try again", "error");
        setDisabled(false);
      }
    });
  };

  useEffect(() => {
    if (authed) {
      setEmail(profile?.email);
    }
  }, [authed, profile]);

  usePageTitle(
    `Want to Bring Your Place to Fudopia? | Fudopia | Meet. Eat. Repeat.`,
  );

  return (
    <div>
      {error && <p className="error-message">Something went wrong...</p>}
      <h1>Want to Bring Your Place to Fudopia?</h1>
      <p className="centered">
        We’d love to hear from you! ✨ Give us the quick intro below. A few
        details, a little about your place, and we’ll take it from there.
      </p>
      <form id="forgot-password-form" onSubmit={handleSubmit}>
        <label htmlFor="name">
          Your Name <span className="required-field">*</span>
        </label>
        <input
          id="name"
          type="text"
          required
          value={name}
          onChange={(event) => {
            setName(event.target.value);
          }}
        />
        <label htmlFor="email">
          Your Email <span className="required-field">*</span>
        </label>
        <input
          id="email"
          type="email"
          required
          value={email}
          onChange={(event) => {
            setEmail(event.target.value);
          }}
        />
        <label htmlFor="title">
          What’s your place called? <span className="required-field">*</span>
        </label>
        <input
          id="title"
          type="text"
          required
          value={title}
          onChange={(event) => {
            setTitle(event.target.value);
          }}
        />
        <label htmlFor="address">
          Where can we find you? <span className="required-field">*</span>
        </label>
        <input
          id="address"
          type="text"
          required
          placeholder="Your address"
          value={address}
          onChange={(event) => {
            setAddress(event.target.value);
          }}
        />
        <label htmlFor="googlemaps">Google Maps link</label>
        <input
          id="googlemaps"
          type="text"
          value={googlemaps}
          onChange={(event) => {
            setGooglemaps(event.target.value);
          }}
        />
        <label htmlFor="link">Website and/or social media links</label>
        <input
          id="link"
          type="text"
          required
          value={link}
          onChange={(event) => {
            setLink(event.target.value);
          }}
        />
        <label htmlFor="info">
          What should we try from your menu, and why?{" "}
          <span className="required-field">*</span>
        </label>
        <textarea
          id="info"
          type="text"
          required
          rows="6"
          value={info}
          onChange={(event) => {
            setInfo(event.target.value);
          }}
        />
        <label htmlFor="description">
          Tell us a little about your place?{" "}
          <span className="required-field">*</span>
        </label>
        <textarea
          id="description"
          type="textarea"
          rows="8"
          required
          value={description}
          onChange={(event) => {
            setDescription(event.target.value);
          }}
        />
        <LoadingButton
          type="submit"
          disabled={disabled}
          color="primary"
          variant="contained"
        >
          Send
        </LoadingButton>
      </form>
    </div>
  );
}

export default RestaurantSubmit;
